import { Tag } from '@cian/components';
import * as React from 'react';

import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IPromoTagItemProps {
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const PromoTagItem = ({ onDeleteClick, withNewTag }: IPromoTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      По акции
    </TagComponent>
  );
};
